import parser from "ua-parser-js"

export function getOS() {
  return parser(navigator.userAgent).os.name;
}

export function getBrowser() {
  return parser(navigator.userAgent).browser.name;
}
